// 地址栏参数解析
function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return(false);
}
// url参数解析
function getUrlkey(url) {
    var params = {};
    var urls = url.split("?");
    var arr = urls[1].split("&");
    for (var i = 0, l = arr.length; i < l; i++) {
      var a = arr[i].split("=");
      params[a[0]] = a[1];
    }
    return params;
}
// ga跟踪代码
function gaPush(dataEvent,lable){
    try{
        dataLayer.push({'event':'online','name':operation,'operation':String(dataEvent),'lable':String(lable)});
    }catch(e){
        console.log(e)
    }
}

var accountProductInfo = {
    "1":{
        "purchase_gateway":[4,7,9,10],
        "default_gateway":10,
    },
}
var buy_first=0;
// 判断是否首次进入页面
if(localStorage.getItem('buy_first')){
    buy_first=1
}else{
    localStorage.setItem('buy_first',1)
}
var isbuy=0;
var fastspringScript;
if(location.hostname=='www.topvox.ai'){
    var paddle_vendor=115664;
    var fast_storefront='topvox.onfastspring.com/popup-topvox';
    var fast_key='FVJN2T7WS1WF38GDJV1AWQ';
}else{
    try{
        Paddle.Environment.set('sandbox');
    }catch(e){console.log(e)}
    var paddle_vendor=570;
    var fast_storefront='topvox.test.onfastspring.com/popup-topvox';
    var fast_key='FVJN2T7WS1WF38GDJV1AWQ';
}

// 存储原始折扣码信息
var originalCouponInfo = {
    plan: null,
    coupon: null
};

// 通用的恢复原始折扣码函数
function restoreOriginalCoupon() {
    if (originalCouponInfo.plan) {
        var button = $('.account_buy[plan="' + originalCouponInfo.plan + '"]');
        if (button.length > 0) {
            button.attr('coupon', originalCouponInfo.coupon);
            console.log('恢复原始折扣码:', originalCouponInfo.coupon, '到产品:', originalCouponInfo.plan);
        }
        // 清空存储的信息
        originalCouponInfo.plan = null;
        originalCouponInfo.coupon = null;
    }
}
try{
    Paddle.Setup({
        vendor: paddle_vendor,
        eventCallback: function(data) {
            console.log(data);
            $('.account_buy').removeClass('load');
            
            // Paddle支付关闭事件
            if (data.event === 'Checkout.Close') {
                restoreOriginalCoupon();
            }
            
            if(data.event === 'Checkout.PaymentMethodSelected'){
                if(!buy_first){
                    gaPush('buy_payment_first','')
                }else{
                    gaPush('buy_payment','')
                }
            }
            if (data.event === 'Checkout.PaymentComplete') {
                isbuy=1;
                gaPush('buy_success','')
            }
            if(data.event === 'Checkout.Close'&&isbuy){
                $('.maskRights').show();
                if(getCookie('user')){
                    $('.buySuccess.Member').show().siblings().hide();
                    gaPush('buy_login','true')
                }else{
                    $('.buySuccess.noMember').show().siblings().hide();
                    gaPush('buy_login','false')
                }
            }
            if(data.event === 'Checkout.Error'){
                gaPush('buy_fail','')
            }
            // 电子商务代码
            if(data.event === 'Checkout.Customer.Details'){
                data.eventData.checkout.prices.customer.items[0].price=data.eventData.checkout.prices.customer.total*1
                var view_item={
                    event:'view_item',
                    ecommerce:{
                        currency: data.eventData.checkout.prices.customer.currency,
                        value: data.eventData.checkout.prices.customer.total*1,
                        item_brand: "Paddle",
                        items:data.eventData.checkout.prices.customer.items
                    }
                }
                dataLayer.push({ecommerce:null});
                dataLayer.push(view_item)
                var add_to_cart={
                    event:'add_to_cart',
                    ecommerce:{
                        currency: data.eventData.checkout.prices.customer.currency,
                        value: data.eventData.checkout.prices.customer.total*1,
                        item_brand: "Paddle",
                        items:data.eventData.checkout.prices.customer.items
                    }
                }
                dataLayer.push({ecommerce:null});
                dataLayer.push(add_to_cart)
            }
            if(data.event === 'Checkout.Payment.Selection'){
                data.eventData.checkout.prices.customer.items[0].price=data.eventData.checkout.prices.customer.total*1
                var begin_checkout = {
                    event:'begin_checkout',
                    ecommerce:{
                        currency: data.eventData.checkout.prices.customer.currency,
                        value: data.eventData.checkout.prices.customer.total*1,
                        coupon: data.eventData.checkout.coupon.coupon_code,
                        item_brand: "Paddle",
                        items:data.eventData.checkout.prices.customer.items
                    }
                }
                dataLayer.push({ecommerce:null});
                dataLayer.push(begin_checkout)
            }
            if(data.event === "Checkout.Complete"){
                data.eventData.checkout.prices.customer.items[0].price=data.eventData.checkout.prices.customer.total*1
                var purchase = {
                    event: "purchase",
                    ecommerce: {
                        transaction_id: data.eventData.checkout.id,
                        value: data.eventData.checkout.prices.customer.total*1,
                        tax: data.eventData.checkout.prices.customer.total_tax*1,
                        shipping: 0.00,
                        currency: data.eventData.checkout.prices.customer.currency,
                        coupon: data.eventData.checkout.coupon.coupon_code,
                        item_brand: "Paddle",
                        items: data.eventData.checkout.prices.customer.items,
                    },
                };
                dataLayer.push({ecommerce:null});
                dataLayer.push(purchase);
            }
        }
    });
}catch(e){
    console.log(e)
}

// 0 正常  1 点击购买打开
var loginBtnState=0;
// 请求购买链接
$('.account_buy').click(function(){
    if($(this).attr('class').indexOf('load')>-1){
        return false;
    }
    var that=$(this)
    that.addClass('load')
    // 设置默认购买
    if(that.attr('data-account-productid') && that.attr('data-account-productid')!=''){
        var current_pid = that.attr('data-account-productid')
        for(var value in accountProductInfo) {
            if(value == current_pid){
                if(!accountProductInfo[value].purchase_gateway.includes(gateway)) {
                    gateway = accountProductInfo[value].default_gateway;
                }
            }
        }
    }
    if(gateway==8 || gateway==10){
        setTimeout(function(){
            $.ajaxSettings.async = false;
            checkout(that);
            $.ajaxSettings.async = true;
            newWindow = window.open(buy_url);
        },20)
    }else{
        checkout(that);
    }
});
var language='en'
var buy_url
var newWindow
function checkout(that){
    var data={
        e_id:murmur,
        gateway:gateway,
        language:language,
        plan_id:that.attr('plan')
    }
    if(that.attr('coupon')){
        data.coupon=that.attr('coupon');
    }
    gaPush('buy_fail','buy_planID',that.attr('plan'))
    $.post(
        post_url+"subscription/checkout",
        data,
        function(data){
            that.removeClass('load')
            error_fn(data.error,that);
            switch(data.error){
                case 0:
                    if(gateway==4){
                        // 2checkout
                        (function (document, src, libName, config,data) {
                            var data=getUrlkey(data.url_gateway)
                            var script             = document.createElement('script'); 
                            script.src             = src; 
                            script.async           = true; 
                            script.id              ='buy2checkout'
                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                            script.onload          = function () {
                                var isbuy=0;
                                for (var namespace in config) {
                                    if (config.hasOwnProperty(namespace)) {
                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                    } 
                                } 
                                window[libName].register();
                                var prod_map = data.prod.split("%3B");
                                var qty_map = data.qty.split("%3B");
                                prod_map.forEach(function(item,index){
                                    TwoCoInlineCart.products.add({
                                        code: item,
                                        quantity: qty_map[index]
                                    })
                                })
                                try{
                                    if(data.test){
                                        TwoCoInlineCart.cart.setTest(true);
                                    }
                                }catch(e){
                                    console.log(e)
                                }
                                if(data.lock){
                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                }else{
                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                }
                                if(data['empty-cart']){
                                    TwoCoInlineCart.cart.setReset(true)
                                }else{
                                    TwoCoInlineCart.cart.setReset(false)
                                }
                                console.log(data,351)
                                if(data.coupon){
                                    TwoCoInlineCart.cart.addCoupon(data.coupon);
                                }
                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                TwoCoInlineCart.cart.setSignature(data.signature)
                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                TwoCoInlineCart.cart.checkout();
                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                    console.log('cart:opened')
                                })
                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                    if(isbuy){
                                        $('.maskRights').show();
                                        if(getCookie('user')){
                                            $('.buySuccess.Member').show().siblings().hide();
                                            gaPush('buy_login','true')
                                        }else{
                                            $('.buySuccess.noMember').show().siblings().hide();
                                            gaPush('buy_login','false')
                                        }
                                    }
                                    // 2Checkout支付关闭事件
                                    restoreOriginalCoupon();
                                })
                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                    isbuy=1;
                                    gaPush('buy_success','')
                                })
                            }; 
                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                        })(document, 'https://store.topvox.ai/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/store.topvox.ai","customization":"inline"}},data); 
                    }else if(gateway==8 || gateway==10){
                        buy_url=data.url_gateway
                    }else if(gateway==7){
                        var key=JSON.parse(window.atob(data.url_gateway.split('base64,')[1]));
                        isbuy=0;
                        if(fastspringScript){
                            fastspring.builder.promo(that.attr('coupon'))
                            fastspring.builder.secure(key.p,key.k);
                            fastspring.builder.checkout();
                        }else{
                            fastspringScript=document.createElement('script'); 
                            fastspringScript.src="https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js"; 
                            fastspringScript.async=true; 
                            fastspringScript.id='fsc-api'
                            fastspringScript.setAttribute('data-storefront',fast_storefront)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-popup-closed','fastspringDataPopupClosed')
                            fastspringScript.setAttribute('data-data-callback','fastspringDataCallback')
                            fastspringScript.setAttribute('data-popup-webhook-received','fastspringDataPopupWebhookReceived')
                            document.body.appendChild(fastspringScript)
                            fastspringScript.onload=function(){
                                fastspring.builder.promo(that.attr('coupon'))
                                fastspring.builder.secure(key.p,key.k);
                                fastspring.builder.checkout();
                            }
                        }
                    }else{
                        isbuy=0;
                        Paddle.Checkout.open({
                            override: data.url_gateway
                        });
                    }
                    break
                case 25301:
                    that.removeClass('load')
                    error(i18n[lang].error_25301);
                    break;
                case 25302:
                    that.removeClass('load')
                    error(i18n[lang].error_25302);
                    break;
                case 25303:
                    that.removeClass('load')
                    error(i18n[lang].error_25303);
                    break;
                case 25304:
                    that.removeClass('load')
                    error(i18n[lang].error_25304);
                    break;
                case 25305:
                    that.removeClass('load')
                    error(i18n[lang].error_25305);
                    break;
                case 25306:
                    that.removeClass('load')
                    error(i18n[lang].error_25306);
                    break;
            }
        }
    ).error(function(xhr){
        overtime(25399);
    });
}
$('.account_buy.unbind').unbind('click');
// $('.maskRights .close').click(function(){
//     $('.maskRights').hide();
//     $('.alert-mask').hide();
// });
// $('.buySuccess .btn').click(function(){
//     $('.maskRights').hide();
//     $('.alert-mask').hide();
// });
// $('.maskMember').load("/mask-member.html",function(){
//     $.getScript(accountHref+"js/mask-member.js",function(){
//         console.log('mask-member')
//     })
//     var link = document.createElement("link");
//     link.type = "text/css";
//     link.rel = "stylesheet";
//     link.href = accountHref+'css/mask-member.css';
//     document.getElementsByTagName("head")[0].appendChild(link);
// });
// // 打开注册弹窗
// $('.registerMaskbtn').click(function(){
//     $('.maskRights').hide();
//     $('.maskMember').show();
//     $('.member>.register').addClass('active').siblings('.box').removeClass('active');
// });
// // 打开登录弹框
// $('.loginMaskbtn').click(function(){
//     $('.maskRights').hide();
//     $('.maskMember').show();
//     $('.member>.login').addClass('active').siblings('.box').removeClass('active');
// });
// if($('.maskMember').length){
//     $('#header .login_btn>a').click(function(){
//         $('.maskMember').show();
//         $('.member>.login').addClass('active').siblings('.box').removeClass('active');
//         return false;
//     });
// }
// // 关闭
// $('.maskMember').on('click','.close',function(){
//     $('.maskMember').hide();
// });
// 地址栏有参数直接打开购买
(function(){
    try{
        var _local = window.location.href.split('?plan=')[1],num=0;
        if(_local.indexOf('&')>-1){
            _local=_local.split('&')[0];
        };
        setTimeout(function(){
            for(var j = 0;j<$('.account_buy').length;j++){
                if($('.account_buy').eq(j).attr('plan')==_local){
                    var currentBtn = $('.account_buy').eq(j);
                    var couponValue = getQueryVariable('coupon');
                    
                    // 保存原始折扣码信息
                    originalCouponInfo.plan = _local;
                    originalCouponInfo.coupon = currentBtn.attr('coupon') || '';
                    
                    // 如果有coupon参数，替换折扣码
                    if(couponValue){
                        currentBtn.attr('coupon', couponValue);
                    }
                    
                    // 调起购买
                    currentBtn.trigger('click');
                    break;
                }
            }
        },1000);
    }catch(e){
        console.log(e);
    }
})();

// FastSpring支付关闭事件处理
function fastspringDataPopupClosed(data) {
    restoreOriginalCoupon();
}